// extracted by mini-css-extract-plugin
export default {"container":"style_container__tIvun","infoMessage":"style_infoMessage__zSO+u","gameCodeInput":"style_gameCodeInput__eZjjB"};